import React, { createContext, useContext, useEffect, useState } from "react";
import client from "../lib/api";
import { useAuth } from "./AuthContext";

const AppContext = createContext(null);
export const useApp = () => useContext(AppContext);

export function AppProvider({ children }) {
  const { user, activeTenantId } = useAuth();
  const [layout, setLayout] = useState(localStorage.getItem("pm_layout") || "standard"); // standard | os
  const [datasets, setDatasets] = useState([]);
  const [datasetId, setDatasetId] = useState(null);
  const [density, setDensityState] = useState(localStorage.getItem("pm_density") || "compact");

  const setLayoutMode = (l) => {
    setLayout(l);
    localStorage.setItem("pm_layout", l);
  };

  const setDensity = (d) => {
    setDensityState(d);
    localStorage.setItem("pm_density", d);
  };

  const loadDatasets = async () => {
    if (!user) return;
    if (user.role === "super_admin" && !activeTenantId) { setDatasets([]); setDatasetId(null); return; }
    try {
      const { data } = await client.get("/datasets");
      setDatasets(data);
      setDatasetId((prev) => (data.find((d) => d.id === prev) ? prev : data[0]?.id || null));
    } catch (e) { /* noop */ }
  };

  useEffect(() => { loadDatasets(); /* eslint-disable-next-line */ }, [user, activeTenantId]);

  const currentDataset = datasets.find((d) => d.id === datasetId) || null;

  return (
    <AppContext.Provider value={{ layout, setLayoutMode, density, setDensity, datasets, datasetId, setDatasetId, currentDataset, loadDatasets }}>
      {children}
    </AppContext.Provider>
  );
}
